import React from 'react'
import { type Row } from '@tanstack/react-table'

import {
  Button,
  ConfirmationPopoverContent,
  Icon,
  Popover,
} from '../../../../module'
import styles from './_spreadsheet-cell.module.scss'
import { c } from '../../../../translations/LibraryTranslationService'

export type DeleteCellProps<TData extends object> = {
  table: {
    options: {
      meta?: {
        removeRow: (rowIndex: number) => void
        isLastRowDeleted?: {
          isRowDelete: boolean
          tooltipMessage: string
          confirmButtonText?: string
        }
      }
      data: TData[]
    }
  }
  row: Row<TData>
}

const DeleteCell = <TData extends object>({
  table,
  row,
}: DeleteCellProps<TData>) => {
  const meta = table?.options?.meta
  const isDeleted =
    meta?.isLastRowDeleted?.isRowDelete && table?.options?.data?.length === 1
  const confirmButtonText =
    meta?.isLastRowDeleted?.confirmButtonText && isDeleted
      ? meta?.isLastRowDeleted?.confirmButtonText
      : c('deleteRow')
  const isRowDeleted =
    table?.options?.data?.length === 1 && !meta?.isLastRowDeleted?.isRowDelete

  return (
    <Popover
      popoverContent={({ setVisible }) => (
        <ConfirmationPopoverContent
          body={
            isDeleted
              ? meta?.isLastRowDeleted?.tooltipMessage
              : c('confirmationDeleteRow')
          }
          cancelCallout={() => setVisible(false)}
          confirmCallout={() => {
            meta?.removeRow(row.index)
            setVisible(false)
          }}
          confirmButtonText={confirmButtonText}
          header={c('deleteRow')}
          type='red'
        />
      )}
      noPadding
      position='top'
    >
      {({ setVisible, visible }) => (
        <div className={styles.deleteCell}>
          <Button
            onClick={() => setVisible(!visible)}
            as='unstyled'
            {...(isRowDeleted
              ? {
                  disabled: true,
                  tooltip: {
                    position: 'top',
                    tooltipContent: (
                      <span>{meta?.isLastRowDeleted?.tooltipMessage}</span>
                    ),
                  },
                }
              : {})}
          >
            <Icon icon='trash' iconSize='16px' color='dark-red' />
          </Button>
        </div>
      )}
    </Popover>
  )
}

export default DeleteCell
